import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { numberFormatter } from 'UI/utils';

import { useStyles } from './styles';

const getLabelByType = label => {
  if (typeof label === 'number') {
    return numberFormatter(label);
  }

  return typeof label === 'string' ? label : '-';
};

const Cell = ({ className, mainLabel, secondaryLabel }) => {
  const classes = useStyles();

  return (
    <TableCell className={clsx(className, classes.cell)}>
      {getLabelByType(mainLabel)}

      {!!secondaryLabel && (
        <>
          <br />
          <Typography variant="caption">{getLabelByType(secondaryLabel)}</Typography>
        </>
      )}
    </TableCell>
  );
};

export default Cell;
